<template>
  <donut-modal
    v-model="isOpen"
    title="Add channel to Team Pulse"
    :cancelable="true"
    :button="null"
    @close="onClose"
  >
    <div class="f-v f-gap-16">
      <div>
        <label class="t-sm bold m-bx1 block">Select channels</label>
        <donut-selector-prefabs-channel
          v-model="selectedChannels"
          :is-multi="true"
          placeholder="Search public Slack channels..."
          :include-private="false"
        />
        <div class="t-sm gray m-tx1">
          Donut will be added to the public channels above
        </div>
      </div>
    </div>
    <template #actions>
      <a class="link p m-r" @click="onClose">Cancel</a>
      <donut-button
        :class="{ disabled: !canSubmit, loading: isSubmitting }"
        @click="onSubmit"
      >
        Add channels
      </donut-button>
    </template>
  </donut-modal>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import Network from 'lib/api/network';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue', 'submitted']);
const store = useStore();

const isOpen = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
});

const selectedChannels = ref([]);
const isSubmitting = ref(false);

const canSubmit = computed(() => {
  const channels = selectedChannels.value;
  return Array.isArray(channels) && channels.length > 0;
});

const onClose = () => {
  if (!isSubmitting.value) {
    selectedChannels.value = [];
    isOpen.value = false;
  }
};

const onSubmit = () => {
  if (!canSubmit.value || isSubmitting.value) return;

  const channelIds = selectedChannels.value.map((channel) => channel.id).filter(Boolean);
  if (channelIds.length === 0) return;

  isSubmitting.value = true;
  Network.post('/team_pulse/add_channels', { channel_ids: channelIds }, {
    success: () => {
      selectedChannels.value = [];
      isOpen.value = false;
      emit('submitted');
    },
    error: (data) => {
      const text = data.responseJSON?.error === 'channels_still_processing'
        ? 'Channels are still processing. Please wait until they are ready before adding more.'
        : 'Unable to add channels right now. Please try again.';
      store.dispatch('setErrorToast', text);
    },
    complete: () => {
      isSubmitting.value = false;
    },
  });
};
</script>
